import { render, staticRenderFns } from "./ReviewsScheduled.vue?vue&type=template&id=6ba5bbb2&scoped=true"
import script from "./ReviewsScheduled.vue?vue&type=script&lang=js"
export * from "./ReviewsScheduled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba5bbb2",
  null
  
)

export default component.exports